import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import icon from '../../images/icon/magic.svg';
import Seo from '../../components/Seo';
import { useAuth } from '../../context/AuthContext';

const PartnerBecome = () => {
    const { t } = useTranslation();
    const { lang } = useParams();
    const { user } = useAuth();

    const benefits = [
        { icon: 'fas fa-handshake', title: t('partners.become.benefit1Title'), desc: t('partners.become.benefit1Desc') },
        { icon: 'fas fa-chart-line', title: t('partners.become.benefit2Title'), desc: t('partners.become.benefit2Desc') },
        { icon: 'fas fa-tools', title: t('partners.become.benefit3Title'), desc: t('partners.become.benefit3Desc') },
        { icon: 'fas fa-users', title: t('partners.become.benefit4Title'), desc: t('partners.become.benefit4Desc') },
    ];

    return (
        <Fragment>
            <Seo title={`${t('partners.become.title')} | OrbitroniX`} description={t('partners.become.subtitle')} url={`/${lang}/partners/become`} />
            <Layout>
                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="page-title pt-150 pos-rel bg_img">
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 }} className="page-title-box">
                                        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="sub-title">
                                            <img src={icon} alt="" /> {t('partners.title')}
                                        </motion.span>
                                        <motion.h2 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7 }} className="title">
                                            🤝 {t('partners.become.title')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.8 }} className="pb-85 cp-det-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="item-details-widget" style={{ padding: '50px' }}>
                                    <p className="text-white-50 mb-4" style={{ fontSize: '18px', lineHeight: '1.8' }}>
                                        {t('partners.become.content')}
                                    </p>
                                    <h3 className="text-white mb-30">{t('partners.become.whyPartner')}</h3>
                                    <div className="row mb-50">
                                        {benefits.map((b, i) => (
                                            <div className="col-md-6 mb-30" key={i}>
                                                <div style={{ background: 'rgba(108,92,231,0.1)', border: '1px solid rgba(108,92,231,0.3)', borderRadius: '12px', padding: '25px' }}>
                                                    <i className={`${b.icon} text-primary mb-3`} style={{ fontSize: '28px' }}></i>
                                                    <h5 className="text-white mb-2">{b.title}</h5>
                                                    <p className="text-white-50 mb-0" style={{ fontSize: '14px' }}>{b.desc}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="item-contact_info">
                                    <div className="orbx-item--inner">
                                        <h3 className="orbx-item--title">{t('partners.become.ready')}</h3>
                                        <p className="text-white-50 mb-4">{t('partners.become.readyDesc')}</p>
                                        {user ? (
                                            <Link to={`/${lang}/partner/dashboard`} className="orbx-btn w-100 text-center">
                                                {t('partners.dashboard.title')} <i className="fas fa-arrow-right"></i>
                                            </Link>
                                        ) : (
                                            <Link to={`/${lang}/login`} className="orbx-btn w-100 text-center">
                                                {t('common.login')} <i className="fas fa-arrow-right"></i>
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>
            </Layout>
        </Fragment>
    );
};

export default PartnerBecome;
